<template>
  <Orders />
</template>
<script>
import appConfig from '@/app.config'
import Orders from '../../../components/skillup/orders/Orders.vue'
export default {
  page: {
    title: 'جزئیات مدیریت سفارشات',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'skillUp-detail-orders',
  components: { Orders },
}
</script>
